import { Form, Formik } from 'formik'
import { ReactNode, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import { Button, FormCheck } from 'react-bootstrap'
import { toast } from 'react-toastify'
import useWorkflowOrgConfig from '../../../../hook/useWorkflowOrgConfig'
import { AppContext } from '../../../appContext/AppContext'
import AutocompleteV2 from '../../../component/AutocompleteObjectV2'
import { TableCollapseCustom } from '../../../component/table/table-collapse/TableCollapseCustom'
import "../../../phan-he-vien-phi/PhanHeVienPhi.scss"
import { getColumnThongTinVienPhi } from '../../../phan-he-vien-phi/columns/thong-tin-vien-phi/ColumnThongTinVienPhi'
import PaymentInfor from '../../../phan-he-vien-phi/components/PaymentInfor'
import { changeOwnExpenses, changeOwnExpensesSingle, changePaymentPercent, getDanhSachDichVu, getPaymentDetail } from '../../../phan-he-vien-phi/services/PhanHeVienPhiServices'
import { CODE, PATH_NAME, RESPONSE_MESSAGE, SIMPLE_CATEGORY_TYPE, TERM_CLASS_IDS, WORKFLOW_ORG_CONFIG_CODE } from '../../../utils/Constant'
import { convertNumberPrice, getErrorMessage } from '../../../utils/FormatUtils'
import { PhanHeTiepDonContext } from '../../contexts/PhanHeTiepDonContext'
import { cancelPaymentSource, changeObjectType, updatePaymentSource } from '../../services/KhamBenhService'
import { getObsComplexCategories } from '../../../phan-he-danh-muc/DanhMucServices'
import { TERM_MODEL_TYPE } from '../../../phan-he-danh-muc/const/constant'
import { getSimpleCategory } from '../../../utils/ServicesUtils'
import { OctContextMenu, OctAutocomplete } from '@oceantech/oceantech-ui'
import { CONTEXT_MENU_CODE } from './constant';
import ConfigOilfuelModal from './components/TransferInfoModal'
import { saveTransferInfo } from '../../services/ThanhToanService'
import { useLocation } from 'react-router-dom'
import { usePhanHeNoiTruContext } from '../../../phan-he-noi-tru/PhanHeNoiTruContext'
import ButtonIn from '../../../component/button-in-phieu'
import { inPhieuDichVuChuaThanhToan } from '../../services/PrintExportService'

type Props = {}

const ACTION = {
    DOI_DT: "doi-doi-tuong",
    DOI_NTT: "doi-nguon-thanh-toan",
    BO_CHON_NTT: "bo-chon-nguon-thanh-toan"
};

const TabThanhToan = (props: Props) => {
    const location = useLocation();
    const isOutpatient = location.pathname === PATH_NAME.KHAM_BENH;
    const { setIsLoading } = useContext(AppContext);
    const { benhNhanInfo } = useContext(PhanHeTiepDonContext);
    const { benhNhanHanhChinh, statusChangedEvent } = usePhanHeNoiTruContext();
    const [dsThongTinDv, setDsThongTinDv] = useState<any[]>([]);
    const [rawDsThongTinDv, setRawDsThongTinDv] = useState<any[]>([]); // Store raw data from backend
    const [arraySelect, setArraySelect] = useState<any[]>([]);
    const [paymentInfor, setPaymentInfor] = useState<any>([]);
    const [paymentItem, setPaymentItem] = useState<any>([]);
    const { config: paymentConfig } = useWorkflowOrgConfig({
        code: WORKFLOW_ORG_CONFIG_CODE.FORM_INFO_PAYMENT
    });
    const [action, setAction] = useState<string>(ACTION.DOI_DT);
    const [objectType, setObjectType] = useState<any>();
    const [paymentSource, setPaymentSource] = useState<any>();
    const [categories, setCategories] = useState<{
		termObjectTypes: any[];
		paymentSources: any[];
	}>({
		termObjectTypes: [],
		paymentSources: [],
	});
    const [selectedCell, setSelectedCell] = useState(null);
    const [contextMenu, setContextMenu] = useState<null | {
        x: number;
        y: number;
    }>(null);
    const [componentKey, setComponentKey] = useState('');
    const [expandedGroups, setExpandedGroups] = useState<Set<string>>(new Set());

    const selectedRowRef = useRef<any>(null);

    const { visit, patient, orderId } = benhNhanInfo?.thongTinKhamBenh || {};
    const visitId = isOutpatient ? visit?.id : benhNhanHanhChinh?.visitId;
    const patientId = isOutpatient ? patient?.id : benhNhanHanhChinh?.patientId;
    const personId = isOutpatient ? patient?.personId : benhNhanHanhChinh?.personId;
    const changeEvent = isOutpatient ? benhNhanInfo?.shouldUpdate : statusChangedEvent;
    const CONTEXT_MENU = [
		...(selectedRowRef.current?.termClassId === TERM_CLASS_IDS.VAN_CHUYEN
			? [
					{
						code: CONTEXT_MENU_CODE.CONFIG_TRANSFER_INFO,
						name: 'Thông tin vận chuyển',
						icon: <i className="bi bi-moisture"></i>,
					},
			  ]
			: []),
	];

    useEffect(() => {
        getCategories();
        document.addEventListener('mousedown', onDocumentClick);

        return () => {
            document.removeEventListener('mousedown', onDocumentClick);
        }
    }, []);

    const onDocumentClick = () => {
      setSelectedCell(null);
    };

    const handleGetPaymentInfor = async () => {
        try {
            let { data } = await getPaymentDetail(visitId)
            if (data?.code === CODE.SUCCESS) {
                setPaymentInfor(data?.data)
            }
        } catch (error) {
            console.error(error);
        }
    }

    const handleSetPaymentInfor = async (paymentConfig: any) => {
        const FORM_FIELD_CONFIG = [
            {
                code: "TONG_CHI_PHI",
                name: "Tổng chi phí",
                value: paymentInfor?.ttTong,
                type: "price",
            },
            {
                code: "GIAM_DICH_VU",
                name: "Giảm dịch vụ",
                value: paymentInfor?.ttDiscountPercent,
                type: "price",
            },
            {
                code: "BENH_NHAN",
                name: "Bệnh nhân",
                value: paymentInfor?.ttNguoiBenh,
                type: "price",
            },
            {
                code: "TAM_UNG",
                name: "Tạm ứng",
                value: paymentInfor?.ttTamUng,
                type: "price",
            },
            {
                code: "DA_CHI",
                name: "Đã chi",
                value: paymentInfor?.ttDaChi,
                type: "price",
            },
            {
                code: "DA_THU",
                name: "Đã thu",
                value: paymentInfor?.ttDaThu,
                type: "price",
                color: "text-danger",
            },
            {
                code: "GIAM_PHIEU_THU",
                name: "Giảm phiếu thu",
                value: paymentInfor?.ttDiscountInv,
                type: "price",
            },
            {
                code: "CON_NO",
                name: paymentInfor?.ttConDu > 0 ? "Còn dư" : "Còn nợ",
                value: paymentInfor?.ttConDu > 0 ? paymentInfor?.ttConDu : Math.abs(paymentInfor?.ttConNo || 0),
                type: "price",
            },
            {
                code: "BHYT",
                name: "BHYT",
                value: paymentInfor?.ttBhyt,
                type: "price",
            },
        ];

        if (!paymentConfig) {
            setPaymentItem(FORM_FIELD_CONFIG);
            return;
        }

        const payments: any[] = [];
        paymentConfig.forEach((item: any) => {
            const paymentItem = FORM_FIELD_CONFIG.find(
                (paymentItem: any) => paymentItem?.code === item
            );
            payments.push(paymentItem);
        });
        setPaymentItem(payments);
    };

    const getInforExpland = () => {
        return (
            <div>
                <div className="fw-bold text-pri text-center">Số tiền thực thu</div>
                <div className="fw-bold text-danger text-center">
                    {paymentInfor?.ttThucTe
                        ? convertNumberPrice(paymentInfor?.ttThucTe)
                        : 0}
                </div>
            </div>
        );
    };

    const renderIcon = (itemOrder: any) => {
        // Check if item is selected (for group or single item)
        const isItemSelected = itemOrder?.isGroupParent
            ? itemOrder?.groupedIds?.every((id: string) => arraySelect.some((item: any) => item?.id === id))
            : arraySelect.some((item) => item?.id === itemOrder?.id);

        switch (action) {
            case ACTION.DOI_DT:
            case ACTION.DOI_NTT:
                return (
                    (itemOrder?.isPaid) ? (
                        <span className="icon-circle-check me-2">
                            <i className="bi-check icon-check"></i>
                        </span>
                    ) : (<FormCheck
                        type="checkbox"
                        className="mgr-3 form-check check-box-vp spaces mt-1 ms-n2"
                        checked={isItemSelected}
                        disabled={itemOrder?.isWithinPackage || (itemOrder?.svcQuantity === 0)}
                        title={itemOrder?.svcQuantity === 0 ? "Không thể chọn dịch vụ có số lượng = 0" : ""}
                        onChange={(e: any) => {
                            if (itemOrder?.isGroupParent) {
                                // Handle group checkbox
                                handleGroupCheckboxChange(itemOrder?.groupedIds, e.target.checked, itemOrder?.children);
                            } else {
                                if (e.target.checked) {
                                    setArraySelect([...arraySelect, itemOrder]);
                                } else {
                                    let prevSelected = arraySelect.filter(
                                        (item) => item?.id !== itemOrder?.id
                                    );
                                    setArraySelect(prevSelected);
                                }
                            }
                        }}
                    />)
                );
            case ACTION.BO_CHON_NTT:
                return (
                    (!itemOrder?.psId) ? ("") : (<FormCheck
                        type="checkbox"
                        className="mgr-3 form-check check-box-vp spaces mt-1 ms-n2"
                        checked={isItemSelected}
                        disabled={itemOrder?.isWithinPackage || (itemOrder?.svcQuantity === 0)}
                        title={itemOrder?.svcQuantity === 0 ? "Không thể chọn dịch vụ có số lượng = 0" : ""}
                        onChange={(e: any) => {
                            if (itemOrder?.isGroupParent) {
                                // Handle group checkbox
                                handleGroupCheckboxChange(itemOrder?.groupedIds, e.target.checked, itemOrder?.children);
                            } else {
                                if (e.target.checked) {
                                    setArraySelect([...arraySelect, itemOrder]);
                                } else {
                                    let prevSelected = arraySelect.filter(
                                        (item) => item?.id !== itemOrder?.id
                                    );
                                    setArraySelect(prevSelected);
                                }
                            }
                        }}
                    />)
                )
            default:
                return "";
        };
    };

    // Group orderData by termSvcCode + price + discount per unit + objectTypeCode + paymentPtPercent + paymentInsPercent
    const groupOrderDataByTermAndObject = useMemo(() => {
        return (orderData: any[]) => {
            const grouped = new Map<string, any>();

            orderData.forEach((item: any) => {
                // Calculate discount per unit to match backend grouping logic
                const discountPerUnit = item?.svcQuantity > 0 ? Math.round((item?.discount || 0) / item?.svcQuantity * 100) / 100 : 0;
                // Use ID if termSvcCode is null to prevent incorrect grouping
                const termKey = item?.termSvcCode || item?.termSvcId || item?.termSvcName || item?.id;
                const groupKey = `${termKey}_${item?.svcPrice || 0}_${discountPerUnit}_${item?.objectTypeCode || ''}_${item?.paymentPtPercent || 0}_${item?.paymentInsPercent || 0}`;

                if (!grouped.has(groupKey)) {
                    // First item in group - create parent
                    grouped.set(groupKey, {
                        ...item,
                        isGroupParent: true,
                        groupKey,
                        children: [item],
                        svcQuantity: item?.svcQuantity || 0,
                        groupedIds: [item?.id],
                    });
                } else {
                    // Add to existing group
                    const parent = grouped.get(groupKey);
                    parent.children.push(item);
                    parent.groupedIds.push(item?.id);
                    parent.svcQuantity += (item?.svcQuantity || 0);

                    // Sum up all monetary totals (match backend logic)
                    parent.svcTotal = (parent.svcTotal || 0) + (item?.svcTotal || 0);
                    parent.svcPtTotal = (parent.svcPtTotal || 0) + (item?.svcPtTotal || 0);
                    parent.discount = (parent.discount || 0) + (item?.discount || 0);
                    parent.paymentInsTotal = (parent.paymentInsTotal || 0) + (item?.paymentInsTotal || 0);
                    parent.paymentInsPtTotal = (parent.paymentInsPtTotal || 0) + (item?.paymentInsPtTotal || 0);
                    parent.totalIns = (parent.totalIns || 0) + (item?.totalIns || 0);
                    parent.paymentPtTotal = (parent.paymentPtTotal || 0) + (item?.paymentPtTotal || 0);

                    // Additional fields
                    parent.paymentPt = (parent.paymentPt || 0) + (item?.paymentPt || 0);
                    parent.paymentPtReceiptIns = (parent.paymentPtReceiptIns || 0) + (item?.paymentPtReceiptIns || 0);
                    parent.paymentPtReceipt = (parent.paymentPtReceipt || 0) + (item?.paymentPtReceipt || 0);
                    parent.svcCollected = (parent.svcCollected || 0) + (item?.svcCollected || 0);
                    parent.svcPaymentSource = (parent.svcPaymentSource || 0) + (item?.svcPaymentSource || 0);
                    parent.svcFeeDifference = (parent.svcFeeDifference || 0) + (item?.svcFeeDifference || 0);

                    // Clone fields: use summed values for display
                    parent.svcPtTotalClone = parent.svcPtTotal;
                    parent.discountClone = parent.discount;
                }
            });

            // Convert to flat array with parent-child structure
            const result: any[] = [];
            grouped.forEach((parent) => {
                const isActuallyGrouped = parent.children.length > 1;

                if (isActuallyGrouped) {
                    // This is a real group with multiple items
                    result.push({
                        ...parent,
                        isGroupParent: true
                    });
                    // If group is expanded, add children
                    if (expandedGroups.has(parent.groupKey)) {
                        parent.children.forEach((child: any) => {
                            result.push({
                                ...child,
                                isGroupChild: true,
                                parentGroupKey: parent.groupKey,
                            });
                        });
                    }
                } else {
                    // Single item - not a group
                    result.push({
                        ...parent,
                        isGroupParent: false,
                        children: undefined,
                        groupedIds: undefined,
                        groupKey: undefined
                    });
                }
            });

            return result;
        };
    }, [expandedGroups]);

    // Toggle expand/collapse for groups
    const handleToggleExpand = useCallback((groupKey: string) => {
        setExpandedGroups(prev => {
            const newSet = new Set(prev);
            if (newSet.has(groupKey)) {
                newSet.delete(groupKey);
            } else {
                newSet.add(groupKey);
            }
            return newSet;
        });
    }, []);

    // Handle checkbox change for grouped items
    const handleGroupCheckboxChange = useCallback((groupedIds: string[], checked: boolean, children?: any[]) => {
        if (checked) {
            // Add all children items that are not already selected
            const childrenToAdd = children?.filter(child =>
                !arraySelect.some(selected => selected?.id === child.id)
            ) || [];
            setArraySelect([...arraySelect, ...childrenToAdd]);
        } else {
            // Remove all items with IDs in groupedIds
            setArraySelect(arraySelect.filter(item => !groupedIds.includes(item?.id)));
        }
    }, [arraySelect]);

    const handleMapDataDSDichVu = (data: any, isFiltered = false) => {
        return data?.map((item: any, index: number) => {
            let dataReturn = item?.orderData;

            // Group orderData by term + object type
            const groupedData = groupOrderDataByTermAndObject(dataReturn || []);

            let orderDataClone = groupedData?.length > 0 ? groupedData.map((itemOrder: any) => {
                return {
                    ...itemOrder,
                    svcPtTotalClone:
                        itemOrder?.svcPtTotalClone === undefined
                            ? itemOrder?.svcPtTotal
                            : itemOrder?.svcPtTotalClone,
                    paymentPtPercentClone:
                        itemOrder?.paymentPtPercentClone === undefined
                            ? itemOrder?.paymentPtPercent
                            : itemOrder?.paymentPtPercentClone,
                    svcPriceClone: itemOrder?.svcPrice,
                    svcCollected: itemOrder?.isPaid ? itemOrder?.svcPtTotal : 0,
                    termSvcNameClone: (
                        <span className="d-flex align-items-center">
                            {/* Expand/Collapse button for grouped items */}
                            {itemOrder?.isGroupParent && itemOrder?.children?.length > 1 ? (
                                <button
                                    className="btn btn-sm btn-link p-0 me-1"
                                    style={{ minWidth: '20px' }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleToggleExpand(itemOrder?.groupKey);
                                    }}
                                    title={expandedGroups.has(itemOrder?.groupKey) ? "Thu gọn" : "Mở rộng"}
                                >
                                    <i className={`bi ${expandedGroups.has(itemOrder?.groupKey) ? 'bi-chevron-down' : 'bi-chevron-right'}`}></i>
                                </button>
                            ) : itemOrder?.isGroupChild ? (
                                // Child item - add spacer to align with parent
                                <span className="me-1" style={{ minWidth: '20px', display: 'inline-block' }}></span>
                            ) : null}

                            {renderIcon(itemOrder)}
                            <span
                                className={`flex-grow-18 ${itemOrder?.isCancel ? "text-danger" : ""} ${itemOrder?.isGroupChild ? 'text-muted' : ''} spaces pl-5`}
                                style={itemOrder?.isGroupChild ? { fontSize: '0.95em' } : {}}
                            >
                                {itemOrder?.termSvcName}
                                {itemOrder?.isGroupParent && itemOrder?.children?.length > 1 && (
                                    <span className="text-primary fw-bold ms-2">({itemOrder?.children?.length} lần)</span>
                                )}
                            </span>
                        </span>
                    ),
                };
            }) : [{}];
            return {
                ...item,
                name: `${index + 1}. ${item?.termClassName}`,
                orderData: orderDataClone,
            };
        });
    };

    const getDanhSachThongTinDichVu = async (clearSelected = true) => {
        setIsLoading(true);
        let searchObject = {
            visitId,
        };
        try {
            if (visitId) {
                const { data } = await getDanhSachDichVu(searchObject);

                if (CODE.SUCCESS === data?.code) {
                    setRawDsThongTinDv(data?.data || []); // Store raw data
                    let dataFormated = handleMapDataDSDichVu(data?.data || []);
                    setDsThongTinDv(dataFormated || []);
                    handleGetPaymentInfor();
                    clearSelected && setArraySelect([]);
                } else {
                    toast.warning(RESPONSE_MESSAGE.ERROR);
                }
            }
        } catch {
            toast.warning(RESPONSE_MESSAGE.ERROR);
        } finally {
            setIsLoading(false);
        }
    };

    const handleChangeAction = (action: any) => {
        setAction(action);
        setObjectType(null);
        setPaymentSource(null);
    }

    const handleChangeObjectType = async (objectType: any) => {
        if (!objectType) return;
        try {
            let submitData = arraySelect.map((item: any) => ({
                orderId: item?.oorderId,
                objectTypeCode: objectType?.code,
                objectTypeName: objectType?.name,
                objectTypeId: objectType?.id,
            }));
            let { data } = await changeObjectType(submitData);
            if (CODE.SUCCESS === data?.code) {
                toast.success("Thành công");
                getDanhSachThongTinDichVu();
            } else {
                let errorMessage = data?.data?.[0]?.errorMessage || data?.message;
                toast.warn(errorMessage);
            }
        } catch (error) {
            console.error(error);
            toast.error(RESPONSE_MESSAGE.ERROR);
        }
    }

    const handleUpdatePaymentSource = async (paymentSource: any) => {
        if (!paymentSource) return;
        try {
            let submitData = arraySelect.map((item: any) => ({
                orderId: item?.oorderId,
                psCode: paymentSource?.psCode,
                psName: paymentSource?.psName,
                psId: paymentSource?.termModelId,
            }));
            let { data } = await updatePaymentSource(submitData);
            if (CODE.SUCCESS === data?.code) {
                toast.success("Thành công");
                getDanhSachThongTinDichVu();
            } else {
                let errorMessage = data?.data?.[0]?.errorMessage || data?.message;
                toast.warn(errorMessage);
            }
        } catch (error) {
            console.error(error);
            toast.error(RESPONSE_MESSAGE.ERROR);
        }
    }

    const handleCancelPaymentSource = async () => {
        try {
            let submitData = arraySelect.map((item: any) => item?.oorderId);
            let { data } = await cancelPaymentSource(submitData);
            if (CODE.SUCCESS === data?.code) {
                toast.success("Thành công");
                getDanhSachThongTinDichVu();
            } else {
                let errorMessage = data?.data?.[0]?.errorMessage || data?.message;
                toast.warn(errorMessage);
            }
        } catch (error) {
            console.error(error);
            toast.error(RESPONSE_MESSAGE.ERROR);
        }
    }

    const handleMapAction = () => {
        switch (action) {
            case ACTION.DOI_DT:
                handleChangeObjectType(objectType);
                break;
            case ACTION.DOI_NTT:
                // If paymentSource is null/empty, cancel payment source (bỏ chọn)
                if (!paymentSource) {
                    handleCancelPaymentSource();
                } else {
                    handleUpdatePaymentSource(paymentSource);
                }
                break;
            case ACTION.BO_CHON_NTT:
                handleCancelPaymentSource();
                break;
            default:
                break;
        };
    }

    useEffect(() => {
        // Reformat from raw data when expandedGroups changes
        if (rawDsThongTinDv.length > 0) {
            let dataFormated = handleMapDataDSDichVu(rawDsThongTinDv);
            setDsThongTinDv(dataFormated || []);
        }
    }, [arraySelect?.length, action, expandedGroups]);

    useEffect(() => {
        setArraySelect([]);
        getDanhSachThongTinDichVu();
    }, [visitId, changeEvent]);

    useEffect(() => {
        handleSetPaymentInfor(paymentConfig);
    }, [paymentInfor, paymentConfig]);

    const getCategories = async () => {
        try {
            const { data} = await getSimpleCategory({
                type: SIMPLE_CATEGORY_TYPE.DOI_TUONG_DICH_VU,
            });
            const paymentSourcesRes = await getObsComplexCategories(TERM_MODEL_TYPE.DM_NGUON_THANH_TOAN);
            setCategories({
                termObjectTypes: data?.data?.content ?? [],
                paymentSources: paymentSourcesRes?.data?.data ?? []
            });
        } catch (error) {
            console.error(error);
        }
    };

    const onCellValueChange = async (
		rowData: any,
		fieldValue: any,
		index: any,
		field: any,
		previousValue: any
	) => {
		try {
			if (!rowData) return;

			const { id, oorderId: orderId } = rowData;

			const fieldUpdateRequest: Record<string, () => Promise<any>> = {
				isOwnExpenses: () =>
					changeOwnExpensesSingle({
						orderId,
						isOwnExpenses: fieldValue,
					}),
				termObjectType: () =>
					changeObjectType([
						{
							orderId,
							objectTypeCode: fieldValue?.code,
							objectTypeName: fieldValue?.name,
							objectTypeId: fieldValue?.id,
						},
					]),
				svcTotalPercent: () =>
					changePaymentPercent({
						id,
						type: 'TT',
						percent: fieldValue,
					}),
				paymentInsPercent: () =>
					changePaymentPercent({
						id,
						type: 'BH',
						percent: fieldValue,
					}),
			};

            setIsLoading(true);
			const response = await fieldUpdateRequest[field]();
			const responseCode = response?.code || response?.data?.code;

			if (CODE.SUCCESS !== responseCode) {
				toast.error(getErrorMessage(response));
				const newRawList = rawDsThongTinDv?.map((item: any) => ({
					...item,
					orderData: item?.orderData?.map((orderItem: any) => {
						if (orderItem?.id === rowData?.id) {
							return {
								...orderItem,
								[field]: previousValue,
							};
						}
						return orderItem;
					}),
				}));
				setRawDsThongTinDv(newRawList);
				setDsThongTinDv(handleMapDataDSDichVu(newRawList));
				return;
			}

			toast.success('Cập nhật dịch vụ thành công');
			getDanhSachThongTinDichVu(false);
		} catch (error) {
			console.error(error);
			toast.error(RESPONSE_MESSAGE.ERROR);
		} finally {
            setIsLoading(false);
        }
	};

    const handleContextMenu = (e: any, row: any) => {
        selectedRowRef.current = row;
        setContextMenu({ x: e.clientX, y: e.clientY });
    };
    
    const onContextMenuClick = (value: any) => {
        const menuActions = {
            [CONTEXT_MENU_CODE.CONFIG_TRANSFER_INFO]: () => {
                setComponentKey('configTransferInfo');
            }
        };
        menuActions[value?.code]?.();
        setContextMenu(null);
    };

    const DynamicComponent = useCallback((key: string) => {
		const componentMapper: Record<string, ReactNode> = {
			configTransferInfo: (
				<ConfigOilfuelModal
					open
					onClose={() => {
						setComponentKey('');
					}}
                    onSave={(data) => onSaveModal('configTransferInfo', data)}
                    itemEdit={{
                        ...selectedRowRef.current,
                        orderId: selectedRowRef.current?.oorderId,
                    }}
				/>
			),
		};

		return componentMapper[key];
	}, []);

    const onSaveModal = async (key: string, data: any) => {
        switch (key) {
            case 'configTransferInfo':
                saveConfigTransferInfo(data);
                break;
            default:
                break;
        }
    }
    
    const saveConfigTransferInfo = async (data: any) => {
      try {
        setIsLoading(true);
        const response = await saveTransferInfo({
            patientId: patientId,
            personId: personId,
            visitId: visitId,
            encounterId: selectedRowRef.current?.encounterId,
            orderId: selectedRowRef.current?.oorderId,
            values: {
                distance: String(data.distance),
                termModelId: data.hospital.termModelId,
                hospital: data.hospital.hospital,
                oilfuel: data.hospital.oilfuel
            },
        });

        if (CODE.SUCCESS !== response.code) {
            toast.error(getErrorMessage(response));
            return;
        }

        getDanhSachThongTinDichVu(false);
        setComponentKey('');
        toast.success('Cập nhật dịch vụ thành công');
      } catch (error) {
        console.error(error);
        toast.error(RESPONSE_MESSAGE.ERROR);
      } finally {
        setIsLoading(false);
      }
    };

    return (
		<div className="TTVienPhi">
			<Formik initialValues={{}} onSubmit={() => {}}>
				<Form>
					<div className="bg-white spaces pt-6 pb-10 spaces">
						<div className="spaces h-40 px-10 py-5 d-flex justify-content-between">
							<div className="d-flex align-items-center">
								<div className="spaces mr-10" style={{minWidth: '250px', zIndex: 100}}>
									<OctAutocomplete
										options={categories.termObjectTypes}
										value={objectType}
										placeholder="-- Đối tượng --"
										getOptionLabel={(option: any) => option?.name || ''}
										getOptionValue={(option: any) => option?.code || ''}
										onChange={(selected: any) => {
											setObjectType(selected);
											setAction(ACTION.DOI_DT);
										}}
										isClearable
										menuPlacement="auto"
									/>
								</div>
								<div className="spaces mr-10" style={{minWidth: '250px', zIndex: 100}}>
									<OctAutocomplete
										options={[
											{ psId: '__REMOVE__', psName: 'Bỏ chọn nguồn thanh toán' },
											...categories.paymentSources
										]}
										value={paymentSource}
										placeholder="-- Nguồn thanh toán --"
										getOptionLabel={(option: any) => option?.psName || ''}
										getOptionValue={(option: any) => option?.psId || ''}
										onChange={(selected: any) => {
											if (selected?.psId === '__REMOVE__') {
												setPaymentSource(null);
												setAction(ACTION.BO_CHON_NTT);
											} else {
												setPaymentSource(selected);
												setAction(ACTION.DOI_NTT);
											}
										}}
										isClearable
										menuPlacement="auto"
									/>
								</div>
							</div>
							<div className="d-flex align-items-center">
								<ButtonIn
									label={<><i className="bi bi-printer me-1"></i>In phiếu</>}
									fetchExport={inPhieuDichVuChuaThanhToan}
                                    params={isOutpatient ? { orderId } : { visitId }}
									className="btn-outline-primary me-2"
								/>
								<Button
									className="btn-fill"
									onClick={handleMapAction}
									disabled={!arraySelect?.length}
								>
									Cập nhật
								</Button>
							</div>
						</div>
						<div className="px-2">
							<em>
								Ghi chú: Các cột có biểu tượng:
								<i className="bi bi-pencil-fill text-dark fs-7 px-2"></i>
								có thể sửa dữ liệu trực tiếp.
							</em>
						</div>
						<TableCollapseCustom
							columns={getColumnThongTinVienPhi(
								true,
								onCellValueChange,
								arraySelect,
								true,
								categories.termObjectTypes,
								selectedCell,
								setSelectedCell
							)}
							data={dsThongTinDv || []}
							childrenField="orderData"
                            className={`thongTinVienPhi overflow-auto spaces h-calc-vh-${isOutpatient ? '475' : '326'}`}
							classNameTable="spaces W-2500"
							handleClickRow={() => null}
							handleContextMenu={(e, row) => {
                                handleContextMenu(e, row);
                            }}
						/>
					</div>
					<div className="bg-white">
						<PaymentInfor
							className="price-info"
							paymentData={paymentItem}
							children={getInforExpland()}
						/>
					</div>
				</Form>
			</Formik>

            {contextMenu && (
                <OctContextMenu
                    handleClickOptionContextMenu={onContextMenuClick}
                    handleCloseMenu={() => setContextMenu(null)}
                    data={CONTEXT_MENU}
                    target={contextMenu}
                />
			)}

            {componentKey && DynamicComponent(componentKey)}
		</div>
	);
}

export default TabThanhToan